import React from 'react';
import createClass from 'create-react-class';
import Header from '../../common/Header.react';
import Footer from '../../common/Footer.react';
import SnappIntro from'./SnappIntro.react';
import SnappFeatures from'./SnappFeatures/SnappFeatures.react';
import DownloadSection from'../DownloadPage/DownloadSection.react';
import DocumentMeta from "react-document-meta";
import SnappFeaturesConfig from '../../../config/SnappFeatures';
import SnappServicesSection from '../SnappServices/SnappServicesSection';

const Meta = require('../../../config/PagesMeta').MainPage;

const MainPage = createClass({
    render() {
        return (
            <div className="MainPage">
                <DocumentMeta {...Meta} />
                <Header />
                <DownloadSection />
                <SnappServicesSection />
                <SnappIntro />
                <SnappFeatures pages={SnappFeaturesConfig} />
                <Footer />
            </div>
        )
    }
});

module.exports = MainPage;



// WEBPACK FOOTER //
// ./src/js/components/Pages/MainPage/MainPage.react.js